/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Related_BodyInputs */

const en_road_dude_related_body = /** @type {(inputs: Road_Dude_Related_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try the Hotel Lobby AI duet trend, where two photos become a performance together.`)
};

const zh_road_dude_related_body = /** @type {(inputs: Road_Dude_Related_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试试 Hotel Lobby AI 合唱玩法，把两张照片变成一段同台表演。`)
};

/**
* | output |
* | --- |
* | "Try the Hotel Lobby AI duet trend, where two photos become a performance together." |
*
* @param {Road_Dude_Related_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_related_body = /** @type {((inputs?: Road_Dude_Related_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Related_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_related_body(inputs)
	return zh_road_dude_related_body(inputs)
});
export { road_dude_related_body as "road_dude.related.body" }